// extracted by mini-css-extract-plugin
export default {"container":"ConsolidatedLoansDialogContent_container__koxEc"};